import { css } from '@emotion/react';
import colors from '../../../Themes/colors';
import fonts from '../../../Themes/fonts';

const { white, orange } = colors;

export const cartContainer = css({
    padding: '20px',
    width: '100%',
    height: '100%',
    marginTop: '40px',

    '@media(min-width: 576px)': {
        padding: '40px',
    },

    '@media(min-width: 1600px)': {
        padding: '40px 120px',
    },
});

export const cartTitle = css({
    // ...fonts.cartTitle,
    color: colors.black,
    fontSize: '32px',
    fontWeight: '700',
    fontFamily: 'Playfair',
});

export const cartItems = css({
    ...fonts.cartItems,
    color: colors.gray,
});

export const cartOrderSummaryContainer = css({
    padding: '20px',
    backgroundColor: colors.white,
    margin: '40px 0px',
    border: '1px solid #E6DFD8',
    borderRadius: '8px',

    '@media(min-width:1200px)': {
        margin: '0px',
        padding: '40px',
    },
});

export const cartOrderSummaryTitle = css({
    color: colors.black,
    fontSize: '24px',
    fontWeight: '700',
    fontFamily: 'Playfair',
});

export const cartOrderSummaryText = css({
    ...fonts.orderSummaryText,
    fontSize: '16px',
    color: colors.black,
    '@media(min-width:576px)': {
        fontSize: '18px',
    },
});

export const cartOrderSummaryColumnRight = css({
    textAlign: 'end',
});

export const cartOrderSummaryRows = css({
    marginTop: '20px',
});

export const promoCodeInput = css({
    ...fonts.productDescriptionText,
    color: colors.gray,
    padding: '10px',
    border: '1px solid #E6DFD8',
    height: '40px',
    borderRadius: '4px',
});

export const redeemButton = css({
    ...fonts.productDescriptionText,
    color: colors.white,
    backgroundColor: '#064E72',
    padding: '6px 10px',
    borderRadius: '4px',
    border: '1px solid #064E72',
    width: '100%',
    '&:hover,&:focus': {
        color: '#064E72',
        backgroundColor: colors.white,
        border: '1px solid #064E72',
    },
});

export const orderTotal = css(cartItems, {
    color: colors.black,
    marginTop: '0px',
    fontSize: '16px',
    fontWeight: 700,

    '@media(min-width:576px)': {
        fontSize: '18px',
        // marginTop: '1.2em',
    },
});

export const editableQuantity = css({
    padding: '12px 15px',
    borderTop: '1px solid #E6DFD8',
    borderBottom: '1px solid #E6DFD8',
    borderRadius: '0px',
});

export const quantityButton = css({
    backgroundColor: 'white',
    color: '#9D8C7B',
    border: '1px solid #E6DFD8',
    width: '40px',
    textAlign: 'center',
    fontSize: '18px',
    borderRadius: '0px',
    '&:hover, &:focus': {
        backgroundColor: '#E6DFD8',
        color: 'unset',
    },
});

export const quantityDropdown = css({
    background: colors.white,
    color: colors.black,
    marginTop: '2px',
});

export const trashButton = css({
    backgroundColor: colors.white,
    color: '#B7916A',
    border: '0px',
    height: 40,
    display: 'flex',
    flex: 1,
    textAlign: 'center',
    '&:hover, &:focus, &:active': {
        backgroundColor: colors.white,
        border: '0px',
        color: '#064E72',
    },
});

export const trashIcon = css({
    cursor: 'pointer',
    alignSelf: 'center',
    width: '20px',
    height: '20px',
});

export const ProductListItemStyle = css({
    font: '16px Archivo-Regular, sans-serif',
    color: colors.black,
    margin: '15px 0px',
});

export const outOfStockText = css({
    fontFamily: fonts.primary,
    fontSize: 14,
    color: colors.primary,
    marginTop: 10,
});

export const continueShopping = css({
    ...fonts.orderSummaryText,
    color: colors.primary,
    padding: '2px 5px 0px',
});

export const slipContainer = css({
    marginTop: 10,

    '@media(min-width: 450px)': {
        width: 300,
    },
});

export const divider = css({
    height: 1,
    width: '100%',
    backgroundColor: colors.primary,
    marginTop: 20,
});

export const paymentMethodCard = css({
    margin: '0px 15px 15px',
    width: '100%',
    height: 60,
    border: '1px solid #E6DFD8',
    borderRadius: 8,

    ':hover': {
        // WebkitBoxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
        // boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
        border: '1px solid #064E72',
    },
});

export const paymentCardLabel = css({
    marginBottom: 0,
    padding: '0px 30px',
    width: '100%',
    height: '100%',
    minHeight: 50,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
});

export const paymentCardLabelSelected = css({
    marginBottom: 0,
    padding: '0px 30px',
    width: '100%',
    height: '100%',
    minHeight: 50,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: colors.white,
    justifyContent: 'space-between',
    border: '1px solid #064E72',
    borderRadius: 8,
});

export const paymentMethodLabel = css({
    color: colors.black,
    fontSize: 16,
    fontWeight: 500,
    fontFamily: 'Acumin VF',
    margin: 0,
    marginLeft: 15,
});

export const inputRadio = css({
    /* The native appearance is hidden */
    appearance: 'none',
    webkitAppearance: 'none',

    /* The background will be the radio dot's color. */
    background: 'white',

    /* The border will be the spacing between the dot and the outer circle */
    border: 'none',

    /* The outline will be the outer circle */
    outline: '2px solid #064E72',

    borderRadius: '50%',
    height: 20,
    width: 20,
    cursor: 'pointer',

    '&:checked': {
        border: '6px solid #064E72',
        outline: '2px solid #064E72',
    },
});

export const fpxBankList = css({
    margin: '15px 15px 15px 0px',
    width: 200,
    height: 90,

    ':hover': {
        WebkitBoxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
        boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
    },

    '@media(max-width: 450px)': {
        width: '100%',
        height: 'auto',
        margin: '3px 3px 3px 3px',
    },
});

export const fpxBankListColumn = css({
    padding: 0,

    '@media(max-width: 450px)': {
        width: '95%',
    },
});

export const paymentMethodIcon = css({
    color: colors.primary,
    // height: 50,
    // width: 50,
    margin: '0px 5px',
});

export const bankOfflineLabel = css({
    position: 'absolute',
    right: 1,
    top: 1,
    border: '1px solid transparent',
    backgroundColor: 'rgb(252, 174, 192)',
    borderRadius: 8,
    fontSize: 12,
    width: 'auto',
    padding: 1,
    margin: 1,
});

export const newCustomerTitle = css({
    ...fonts.cartTitle,
    color: colors.white,
});

export const newCustomerText = css({
    ...fonts.productDescriptionText,
    color: colors.white,
});

export const returningCustomerTitle = css({
    ...fonts.cartTitle,
    color: colors.black,
});

export const returningCustomerText = css({
    ...fonts.productDescriptionText,
    color: colors.black,
});

export const checkoutTitle = css({
    font: fonts.tertiary,
    fontWeight: '700',
    color: white,
    marginTop: '20px',
    marginBottom: '20px',
    '@media(min-width: 1200px)': {
        font: '35px Archivo-Regular, serif',
        marginTop: '20px',
        marginBottom: '20px',
    },
});

export const cartProductDetailsTable = css({
    borderBottom: '1px solid #E6DFD8',
});
